<div class="progress-bar-container">
  <div class="progress-bar-inner" [style.width.%]="value * 100"></div>
</div>
